import React, { Component } from 'react'
// 이유는 모르겠지만 밑에걸 지우면 크롬에서 에러남
import './variables'
// import {
//   AddOnArray1,
//   AddOnArray2,
//   AddOnArray3,
//   AddOnArrayFavorite,
//   AddOnArraySharing
// } from '../components/addon/addonRegister'
import { getIdForRenderTileInJSON } from '../components/list/window2/functions'
import { uniqueId, debounce } from 'lodash'
import { InsertFormArray } from '../components/addon/addons/parts/forEachInsertForm/insertFormRegister'
import {
  updateChatMemoToCloudDebounced,
  updateConfigToCloud
} from '../backend/configs/updateData'
import { updateTreeNode } from '../backend/treeNode/updateData'
import { createTreeNode } from '../backend/treeNode/createData'
import { deleteTreeNode } from '../backend/treeNode/deleteData'
import importTreeNodes from '../backend/treeNode/importData'
import { produce } from 'immer'
import { configKeysForCloud } from './configs'
import { shouldNodeDeleted } from './functions'

const convertOnDemandStateToContext = (that) => {
  const returnObj = {}

  const stateOnDemand = that
  for (let key of Object.keys(stateOnDemand)) {
    returnObj[key] = () => (stateOnDemand[key])
    if (configKeysForCloud.some((cloudKey) => (cloudKey === key))) {
      const updateConfigToCloudDebounced = debounce(updateConfigToCloud, 500, { leading: false, trailing: true })
      returnObj[`set_${key}`] = (value) => {
        if (stateOnDemand[key] !== value) {
          stateOnDemand[key] = value
          updateConfigToCloudDebounced([key])
        }
      }
    } else if (key === 'chatMemoValue') {
      returnObj[`set_${key}`] = (value) => {
        stateOnDemand[key] = value
        updateChatMemoToCloudDebounced(value)
      }
    } else {
      returnObj[`set_${key}`] = (value) => { stateOnDemand[key] = value }
    }
    if (typeof stateOnDemand[key] === 'object') {
      returnObj[`setSub_${key}`] = (valueObject) => { stateOnDemand[key] = Object.assign(stateOnDemand[key], valueObject) }
    }
  }

  return returnObj
}
// context에서 stateOnDemand값 참조하려면 한번 함수호출 거쳐야됨. Provider.value에 전해지는 각 값들을 () => {}로 감쌌음
const onDemandVars = {
  nodeSelection: {
    start: 0,
    end: 0
  },
  preventFocusSteal: false,
  openNodePopover: false,
  getNodeStateValue: () => {},
  setNodeStateValue: () => {},
  getNodeSelection: () => {},
  setNodeSelection: () => {},
  updateCurrentNodeByChangeOfContents: (f) => { f() },
  focusToLastNode: () => false,
  lastFocusWindowId: null,
  focusToWindow: null,
  focusToNodeOfCurrentWindow: null,
  focusToLastOpenedWindow: () => {},
  focusToPreviousWindow: () => {},
  focusToNodeOfLastOpenedWindow: () => {},
  arrayOfFocusToNodeOfLastOpenedWindow: [],
  arrayOfFocusToNodeOfLastOpenedWindowForPixelMode: [],

  focusToChatMemo: () => {},

  onBlurForPrevNode: () => {},

  updateWindow2InitialValue: () => {},

  isMosaicWindowDragging: false,

  globalTreeData: [],
  changedPath: null,
  changedPrevPath: null,
  changedTreeId: null,
  changeType: null,
  changedNode: null,
  changedParentNode: null,

  // booleanOfIsThisNewOne: {},

  safeFocused: true,

  dragHoveredTreeId: null,
  resetTreeForDragging: () => {},

  Window2InitialValue: null,
  Window2InitialValueForGlobalId: null,

  knowledgeTreeMode: 'reference',

  sidebarCurrent: '1',
  sidebarValue: null,
  hideSidebar: true,

  chatMemoValue: '',
  chatMemoConfig: {
    heightOfFieldRatio: 0,
    widthOfField: 1024
  },

  insertConfig: {
    dockVisible: false,
    dockHeight: 0.4,
    // notSidebarWidthPercent: 80,
    sidebarVisible: true
  },
  setSidebarDirection: () => {},

  limitNodeHeight: true,

  topRootName: 'My Notes',

  focusTodoListInput: () => { return false },
  focusSearchInput: () => { return false },

  stopwatchClearTime: null,
  stopwatchPrevTimeList: [],

  type1Count: 0,
  // type1Items 는 밑의 context.state 에서의 waitingList나 usedList에서 삭제가 일어나도 삭제가 안일어나고 계속 보존되는거임!!!!!!
  // type1Items: [].concat(getDummyType1Items(70)),
  type1Items: [],

  openGlobalDialog: (title, children, type) => false,
  closeGlobalDialog: () => {},
  // -----------------------------------------------------------------------------------------------------------
  // TODO pixelMode 이거 이렇게 바꾼게 될라나?
  // isPixelMode: false,
  isPixelMode: false,
  pixelTreeData: [],
  Window2InitialValueForPixelMode: null,
  // -----------------------------------------------------------------------------------------------------------
  refresh: () => {},
  // -----------------------------------------------------------------------------------------------------------
  isMemorizingAlreadyEntered: false,
  chatMemoConfigForMemorizing: {
    heightOfFieldRatio: 0,
    widthOfField: 1024
  },
  chatMemoValueForMemorizing: [],
  splitPercentageBetweenQuizAndChatMemo: 60,

  PhaseInstance: null,
  setProgressRate: () => {},
  setSubtitleOpenObject: {},
  subtitleOpenObject: {},
  everythingIsAsBefore: true,
  // -----------------------------------------------------------------------------------------------------------
  spreadsheets: {},
  changedSpreadsheetInfo: {},
  // -----------------------------------------------------------------------------------------------------------
  uploadType2s: {},
  changedUploadType2Info: {},
  // -----------------------------------------------------------------------------------------------------------
  selectedNodes: new Set(),
  // -----------------------------------------------------------------------------------------------------------
  importedNodes: [],
  // -----------------------------------------------------------------------------------------------------------
  skipIds: [],
  thoroughIds: [],
  addedThoroughIds: [],
  subsetIds: [],
  subsetBunchNodeIdArrayArray: [],
  showMemorizingSetting: false,
  dailyLimit: 0,
  dailyLimitOn: false,
  orderByTree: true,
  nodeTogetherValue: 30,
  wrongNodeDescendants: 'two',
  delayOn: true,
  delayValue: 22,
  ratingConstants: {
    intervalWeightForDown: 0.1,
    difficultyWeightForDown: (5 / 6),
    intervalWeightForUp: 4,
    difficultyWeightForUp: 1,
    failC: 2
  },
  algorithmConstants: {
    easyValue: 10 / 9,
    normalValue: 8 / 9,
    hardValue: 0.6
  },
  learningTrickBooleans: {
    dontCheckAnswers: false,
    fullScreen: false,
    intermittentReinforcement: {
      active: false,
      sound: true
    },
    obfuscation: false,
    earlyShortBreak: false,
    breakSchedule: {
      active: false,
      mode: '52/17',
      learningTimeFor52: 52,
      learningTimeForPomodoro: 25,
      shortBreakForPomodoro: 5,
      longBreakForPomodoro: 15,
      countForPomodoro: 4
    },
    ambientSound: {
      active: false,
      mode: '1'
    },
    dopamineBoosting: {
      active: false,
      sound: true
    }
  },
  // -----------------------------------------------------------------------------------------------------------
  chartIds: null,
  nodeIdsOfCharts: null,
  booleansOfCharts: null,
  memorizeRunRecord: null,
  memorizeCompleteRecord: null,
  totalSynapses: 0,
  // -----------------------------------------------------------------------------------------------------------
  helpSectionOpen: true,
  helpSectionId: 'tour',
  // -----------------------------------------------------------------------------------------------------------
  isOnline: window.navigator.onLine,
  userData: null,
  email: '',
  // -----------------------------------------------------------------------------------------------------------
  timeRecords: {
    total: new Date(),
    organize: null,
    memorize: null,
    dashboard: null,
    playground: null
  },
  // -----------------------------------------------------------------------------------------------------------
  isMobile: false,
  // -----------------------------------------------------------------------------------------------------------
  sharedNodeIds: [],
  isSharing: false,
  sharingUserId: null,
  sharedNodeId: null,
  sharedNode: null,
  sharedNodePath: [],
  // -----------------------------------------------------------------------------------------------------------
  learningCourseOpened: false,
  buttonMode: 'simple',
  // -----------------------------------------------------------------------------------------------------------
  boxHighlights: {},
  // -----------------------------------------------------------------------------------------------------------
  darkMode: false
}
if (InsertFormArray) {
  InsertFormArray.forEach((ForInsertForm) => {
    onDemandVars[`CountFor${ForInsertForm.type}`] = 1
    // onDemandVars[`initialListOf${ForInsertForm.type}`] = []
  })
}

const globalOnDemandVars = convertOnDemandStateToContext(onDemandVars)
// -----------------------------------------------------------------------------------------------------------
const generateAndRegisterSetContexts = (that, targetObject) => {
  const state = that.state
  for (let key of Object.keys(state)) {
    targetObject[key] = () => (that.state[key])
    // -----------------------------------------------------------------------------------------------------------
    let doSomethingElse = null
    if (configKeysForCloud.some((cloudKey) => (cloudKey === key))) {
      const updateConfigToCloudDebounced = debounce(updateConfigToCloud, 500, { leading: false, trailing: true })
      doSomethingElse = () => {
        updateConfigToCloudDebounced([key])
      }
    } else if (key === 'treeChangeDetect') {
      doSomethingElse = () => {
        globalOnDemandVars.set_everythingIsAsBefore(false)

        if (!(globalOnDemandVars.isPixelMode())) {
          const type = globalOnDemandVars.changeType()
          if (type === 'node') {
            return
          }

          const node = globalOnDemandVars.changedNode()
          const parentNode = globalOnDemandVars.changedParentNode()
          if (process.env.NODE_ENV !== 'production') {
            console.tron.display({
              name: 'in set treeChangeDetect / treenode',
              preview: type,
              value: {
                type,
                node,
                parentNode
              }
            // , important: true
            })
          }

          if (type === 'moveNode' || type === 'addition') {
            // const onFulfilled = async () => {
            //   // TODO 이거 구현 다한다음에 updateTreeNode를 사용안하고 어차피 하는 udpateTreeNode에다 한번에 하게 리팩토링하기...!임!
            //   const parentNodeChildren = parentNode ? parentNode.children : globalOnDemandVars.globalTreeData()
            //   const currentNodeIndexInParentNode = parentNodeChildren.findIndex((anotherNode) => (node.id === anotherNode.id))
            //   const lengthOfParentNodeChildren = parentNodeChildren.length
            //
            //   let orderAsChildOfCurrentNode
            //   if (currentNodeIndexInParentNode === -1) {
            //     throw (new Error('currentNodeIndexInParentNode === -1'))
            //   } else if (currentNodeIndexInParentNode === (lengthOfParentNodeChildren - 1)) {
            //     orderAsChildOfCurrentNode = parentNodeChildren[lengthOfParentNodeChildren - 2].orderAsChild + 1
            //   } else if (currentNodeIndexInParentNode === 0) {
            //     if (lengthOfParentNodeChildren === 1) {
            //       orderAsChildOfCurrentNode = 0
            //     } else {
            //       orderAsChildOfCurrentNode = (parentNodeChildren[1] / 2)
            //     }
            //   } else {
            //     orderAsChildOfCurrentNode = ((parentNodeChildren[currentNodeIndexInParentNode - 1].orderAsChild + parentNodeChildren[currentNodeIndexInParentNode + 1].orderAsChild) / 2)
            //   }
            //
            //   console.tron.display({
            //     name: 'onFulfilled / treeNode / boolean2',
            //     preview: node.id,
            //     value: {
            //       type,
            //       node,
            //       parentNode,
            //       parentNodeChildren,
            //       currentNodeIndexInParentNode,
            //       orderAsChildOfCurrentNode
            //     }
            //     // , important: true
            //   })
            //
            //   return updateTreeNode(node.id, { orderAsChild: orderAsChildOfCurrentNode })
            // }

            let parentId
            if (parentNode) {
              parentId = parentNode.id || 'rootNode'
            } else {
              parentId = 'rootNode'
            }

            let orderAsChildOfCurrentNode
            const parentNodeChildren = parentNode ? parentNode.children : globalOnDemandVars.globalTreeData()
            const currentNodeIndexInParentNode = parentNodeChildren.findIndex((anotherNode) => (node.id === anotherNode.id))
            const lengthOfParentNodeChildren = parentNodeChildren.length
            if (currentNodeIndexInParentNode === -1) {
              if (process.env.NODE_ENV !== 'production') {
                console.tron.display({
                  name: 'currentNodeIndexInParentNode === -1',
                  value: {
                    currentNodeIndexInParentNode,
                    parentNodeChildren,
                    parentNode
                  },
                  important: true
                })
              }
              throw (new Error('currentNodeIndexInParentNode === -1'))
            } else if (currentNodeIndexInParentNode === 0) {
              if (lengthOfParentNodeChildren === 1) {
                orderAsChildOfCurrentNode = 0
              } else {
                orderAsChildOfCurrentNode = Math.ceil(parentNodeChildren[1].editableValues.orderAsChild - 1)
              }
            } else if (currentNodeIndexInParentNode === (lengthOfParentNodeChildren - 1)) {
              orderAsChildOfCurrentNode = Math.floor(parentNodeChildren[lengthOfParentNodeChildren - 2].editableValues.orderAsChild + 1)
            } else {
              orderAsChildOfCurrentNode = ((parentNodeChildren[currentNodeIndexInParentNode - 1].editableValues.orderAsChild + parentNodeChildren[currentNodeIndexInParentNode + 1].editableValues.orderAsChild) / 2)
            }
            node.editableValues.orderAsChild = orderAsChildOfCurrentNode

            if (process.env.NODE_ENV !== 'production') {
              console.tron.display({
                name: 'treeNode / moveNode / input',
                preview: node.id,
                value: {
                  type,
                  node,
                  parentNode,
                  parentNodeChildren,
                  parentId,
                  currentNodeIndexInParentNode,
                  orderAsChildOfCurrentNode
                }
              // , important: true
              })
            }

            if (node.isNewOne && node.isNewOne.boolean2) {
              if (node.isImportedNode) {
                importTreeNodes(node, { parentId, orderAsChild: orderAsChildOfCurrentNode }).then(() => {
                  node.isNewOne.boolean2 = false
                })
              } else {
                if (process.env.NODE_ENV !== 'production') {
                  console.tron.log(`${node.id} boolean2 true`)
                }
                const input = { parentId, orderAsChild: orderAsChildOfCurrentNode }
                if (node.isSpreadsheet) {
                  input.isSpreadsheet = true
                  input.spreadsheetId = node.spreadsheetId
                } else if (node.isUploadType2) {
                  input.isUploadType2 = true
                  input.uploadType2Id = node.uploadType2Id
                  input.title = node.title
                }
                createTreeNode(node.id, input).then(() => {
                  node.isNewOne.boolean2 = false
                })
              }
              // 모든 node가 parentId를 갖고있단걸 보장하자 / 그리고 여기서 parentId는 서버에 등록된게 아니라 localId일거임
              node.parentId = parentId
              node.editableValues.parentId = parentId
            } else {
              if (process.env.NODE_ENV !== 'production') {
                console.tron.log(`${node.id} boolean2 true`)
              }
              updateTreeNode(node.id, { parentId, orderAsChild: orderAsChildOfCurrentNode })
              node.parentId = parentId
              node.editableValues.parentId = parentId
            }
          } else if (type === 'remove') {
            node.prevParentId = (node.editableValues.parentId || node.parentId)
            node.removedAfterStart = true

            if (!shouldNodeDeleted(node)) {
              updateTreeNode(node.id, {
                parentId: 'removed',
                prevParentId: (node.editableValues.parentId || node.parentId),
                removedTime: Date.now()
              }).then(() => {
                // node.removedAfterStart = true
                // node.prevParentId = (node.editableValues.parentId || node.parentId)
                globalOnDemandVars.set_removedNodes(produce(globalOnDemandVars.removedNodes(), draft => {
                  draft.unshift(node)
                }))
              })
            } else {
              deleteTreeNode(node.id)
            }
          }
        }
      }
    } else if (key === 'spreadsheetChangeDetect') {
      doSomethingElse = () => {
        globalOnDemandVars.set_everythingIsAsBefore(false)
      }
    } else if (key === 'uploadType2ChangeDetect') {
      doSomethingElse = () => {
        globalOnDemandVars.set_everythingIsAsBefore(false)
      }
    }

    targetObject[`set_${key}`] = (nextValue) => {
      const nextState = {}
      doSomethingElse && doSomethingElse()
      nextState[key] = nextValue
      that.setState(nextState)
    }
  }
}

export const GlobalContext = React.createContext({
  treeChangeDetect: false
})

class ContextProvider extends Component {
  constructor (props) {
    super(props)
    // let initialValue
    const window2InitialValue = globalOnDemandVars.Window2InitialValue()
    // if (window2InitialValue) {
    //   initialValue = window2InitialValue
    // } else {
    //   initialValue = getIdForRenderTileInJSON(uniqueId(), [])
    // }
    let initialValueForPixelMode
    const window2InitialValueForPixelMode = globalOnDemandVars.Window2InitialValueForPixelMode()
    if (window2InitialValueForPixelMode) {
      initialValueForPixelMode = window2InitialValueForPixelMode
    } else {
      initialValueForPixelMode = getIdForRenderTileInJSON(uniqueId(), [])
    }
    // -----------------------------------------------------------------------------------------------------------
    const stateObject = {
      treeChangeDetect: false,
      dockVisibleAndTop: false,
      chatMemoCovered: false,
      mosaicValue: window2InitialValue,
      lastClosedList: [],
      bookmarkIds: [],
      removedNodes: [],
      guideType: null,
      todoListItems: [],
      stopwatchTime: {
        startTime: null,
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
        pauseOffset: 0
      },
      focusedNode: null,
      // -----------------------------------------------------------------------------------------------------------
      waitingItemsForType1: [],
      usedItemsForType1: [],
      // -----------------------------------------------------------------------------------------------------------
      uploadType2sInWaitingList: [],
      uploadType2ChangeDetect: false,
      // -----------------------------------------------------------------------------------------------------------
      treeChangeDetectForPixelMode: false,
      mosaicValueForPixelMode: initialValueForPixelMode,
      lastClosedListForPixelMode: [],
      // -----------------------------------------------------------------------------------------------------------
      spreadsheetChangeDetect: false,
      // -----------------------------------------------------------------------------------------------------------
      courseStatus: {
        totalSynapses: 0,
        targetSynapses: 0,
        formedSynapses: 0,
        targetNotes: 0,
        completedNotes: 0
      },
      // -----------------------------------------------------------------------------------------------------------
      configReady: false,
      chatMemoReady: false,
      addOnsReady: false,
      type1Ready: false,
      typeListsReady: false,
      treeNodesReady: false,
      onboardingReady: false,
      spreadsheetReady: false,
      uploadType2Ready: false,
      // -----------------------------------------------------------------------------------------------------------
      forceSignInPage: false,
      // -----------------------------------------------------------------------------------------------------------
      intermittentReinforcementTrigger: false,
      earlyShortBreakCount: 0,
      ambientSoundMode: 0,
      dopamineBoostingSound: false,
      dopamineBoostingTrigger: false,
      breakScheduleMode: false,
      // -----------------------------------------------------------------------------------------------------------
      saveState: 'saved',
      // -----------------------------------------------------------------------------------------------------------
      canNotSharedBecause: ''
    }
    InsertFormArray.forEach((ForInsertForm) => {
      stateObject[`itemsFor${ForInsertForm.type}`] = []
    })
    this.state = stateObject
    generateAndRegisterSetContexts(this, globalOnDemandVars)
  }

  // {
  //   updateCurrentNodeByChangeOfContents: this.state.updateCurrentNodeByChangeOfContents,
  //   set_updateCurrentNodeByChangeOfContents: (f) => { this.setState({ updateCurrentNodeByChangeOfContents: f }) }
  // }
  render () {
    return (
      // <GlobalContext.Provider value={convertStateToContext(this)}>
      <GlobalContext.Provider value={this.state}>
        {this.props.children}
      </GlobalContext.Provider>
    )
  }
}

export default ContextProvider
export { globalOnDemandVars }
